<script setup>
import { ref, onMounted } from "vue";
import { Modal } from "bootstrap";

const props = defineProps({
  order: { type: Object, default: null }
});

// modal ka ref
const modalEl = ref(null);
let modalInstance = null;

// Bootstrap modal instance create karna
onMounted(() => {
  if (modalEl.value) {
    modalInstance = new Modal(modalEl.value, {
      backdrop: "static",
      keyboard: true,
    });
  }
});

// modal open function
const openModal = () => {
  if (modalInstance) modalInstance.show();
};

// modal close function
const closeModal = () => {
  if (modalInstance) modalInstance.hide();
};

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const options = { year: "numeric", month: "short", day: "numeric" };
  return new Date(dateStr).toLocaleDateString(undefined, options);
};

// expose functions (agar parent component se call karna ho)
defineExpose({ openModal, closeModal });
</script>

<template>
  <!-- Modal -->
  <div class="modal fade" ref="modalEl" tabindex="-1">
    <div 
  class="modal-dialog modal-dialog-centered" 
  style="max-width: 70%; width: 70%;"
>

      <div class="modal-content" v-if="order">
        <div class="modal-header">
          <h5>Invoice #{{ order.order_refno }}</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>

        <div class="modal-body">
          <!-- Billing Info -->
      <div class="mb-3">
  <h6>Billing Info</h6>

  <div class="row mb-2">
    <div class="col-md-3">
      <p><strong>Name:</strong> {{ order.ord_fname }} {{ order.ord_lname }}</p>
    </div>
     <div class="col-md-3">
      <p><strong>Order ID:</strong> {{ order.order_refno }}</p>
    </div>
     <div class="col-md-3">
      <p><strong>Phone:</strong> {{ order.ord_phone }}</p>
    </div>
    <div class="col-md-3">
      <p><strong>Email:</strong> {{ order.ord_email }}</p>
    </div>
    <!-- <div class="col-md-3">
      <p><strong>Order Date:</strong> {{ formatDate(order.orderdate) }}</p>
    </div>
    <div class="col-md-3">
      <p><strong>Payment:</strong> {{ order.payment_method }}</p>
    </div> -->

  </div>

   <!-- <div class="row mb-2">
   <div class="col-md-3">
      <p><strong>Phone:</strong> {{ order.ord_phone }}</p>
    </div>
    <div class="col-md-3">
      <p><strong>Email:</strong> {{ order.ord_email }}</p>
    </div>
    <div class="col-md-6">
      <p><strong>Status:</strong> {{ order.status }}</p>
    </div>
  </div> -->

  <div class="row mb-2">
    <div class="col-md-12">
      <p><strong>Address:</strong>
        {{ order.ord_address1 }}, {{ order.ord_city }},
        {{ order.ord_state }}, {{ order.ord_country }}
      </p>
    </div>
  </div>

</div>

          <!-- Items -->
           <h6 class="w-bold">Order Items</h6>
          <div class="table-responsive mt-2">
            <table class="table">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th style="width:150px">Course Title</th>
                   <th>Course Code</th>
                   <th>Ticket  Title</th>
                   <th>First Name</th>
                  
                  <th>Last Name</th>
                   <th>Email</th>
                  <th>Status</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in order.items" :key="item.id">
                  <td>{{ index + 1 }}</td>
                  <td style="width:150px">
                    {{ item.course?.ctitle }}
                  </td>
                  <td>
                    {{ item.course?.code }}
                  </td>
                   <td>{{ item.session?.stitle }}</td>
                   <td>{{ item.attendee?.fname || '' }}</td>
                    <td>{{ item.attendee?.lname || '' }}</td>
                    <td>{{ item.attendee?.email || '' }}</td>

                    <td>{{ item.attendee_name }}</td>
                  <td>{{ item.quantity }}</td>
                    <td>
                      <span v-if="parseFloat(item.perprice) > 0">
                        ${{ parseFloat(item.perprice).toFixed(2) }}
                      </span>
                      <span v-else class="badge bg-success text-white px-2 py-1">
                        Free
                      </span>
                      <!-- Show coupon/sponsor code if item is free -->
                      <div v-if="item.is_free || parseFloat(item.perprice) === 0" class="mt-1">
                        <small v-if="item.sponsor_code" class="text-muted d-block">
                          <i class="fa fa-tag me-1"></i>Code: <strong>{{ item.sponsor_code.code }}</strong>
                        </small>
                        <small v-else-if="item.deal_name" class="text-muted d-block">
                          <i class="fa fa-tag me-1"></i>Offer: <strong>{{ item.deal_name }}</strong>
                        </small>
                      </div>
                    </td>

                    <td>
                      <span v-if="parseFloat(item.totalprice) > 0">
                        ${{ parseFloat(item.totalprice).toFixed(2) }}
                      </span>
                      <span v-else class="badge bg-success text-white px-2 py-1">
                        Free
                      </span>
                    </td>

                </tr>
              </tbody>
            </table>
          </div>

          <!-- Total -->
          <div class="text-end mt-3">
            <h5>Total: ${{ parseFloat(order.total_amount).toFixed(2) }}</h5>
            <p>Status: <span class="badge bg-success">{{ order.status }}</span></p>
            <p>Payment Method: {{ order.payment_method }}</p>
            <p>Order Date: {{ formatDate(order.orderdate) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>







